import script from "./Notifications.vue?vue&type=script&setup=true&lang=js"
export * from "./Notifications.vue?vue&type=script&setup=true&lang=js"

import "./Notifications.vue?vue&type=style&index=0&id=59a5c428&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59a5c428"]])

export default __exports__